import { jwtDecode } from 'jwt-decode';
import * as jose from 'jose';
export const getResFromJWTToken = (token: string) => {
	return jwtDecode(token);
};

export const encodeToJWTtoken = async (data: any) => {
	const token = new TextEncoder().encode('MESC_DCAFE_KEY');
	const jwtToken = await new jose.SignJWT(data).setProtectedHeader({ alg: 'HS256' }).sign(token);
	return jwtToken;
};
